import { User } from 'oidc-client';

export type AuthUser = {
  username: string;
  token: string;
  rol?: string;
  acceptedLegal?: boolean;
};

const getAuthorizationHeaderValue = (user?: User): string =>
  user && user.token_type && user.access_token
    ? `${user.token_type} ${user.access_token}`
    : '';

const mapUser = (user?: User, rol?: string, acceptedLegal?: boolean): AuthUser | undefined =>
  user
    ? {
        username: user?.profile?.name || '',
        token: user?.access_token,
        rol: rol,
        acceptedLegal: acceptedLegal
      }
    : undefined;

export { getAuthorizationHeaderValue, mapUser };
